import { backendPort } from '../config';

const base_url = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:' + backendPort + '/api';

export function login(user) {
	return fetch(`${base_url}/login`, {
		method: 'POST',
		body: JSON.stringify(user),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function getNodos() {
	return fetch(base_url).then((res) => res.json());
}

export function postNodo(data) {
	return fetch(base_url + '/create', {
		method: 'POST',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function getIntents() {
	return fetch(base_url + '/intents').then((res) => res.json());
}

export function getEntities() {
	return fetch(base_url + '/entities').then((res) => res.json());
}

export function postIntent(data) {
	return fetch(base_url + '/intents/create', {
		method: 'POST',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function postEntity(data) {
	return fetch(base_url + '/entities/create', {
		method: 'POST',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function putArista(id, data) {
	return fetch(base_url + '/edit/' + id, {
		method: 'PUT',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}
export function putIntent(id, data) {
	return fetch(base_url + '/intents/edit/' + id, {
		method: 'PUT',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function putEntity(id, data) {
	return fetch(base_url + '/entities/edit/' + id, {
		method: 'PUT',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function deleteIntent(id) {
	return fetch(base_url + '/intents', {
		method: 'DELETE',
		body: JSON.stringify({ _id: id }),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function deleteEntity(id) {
	return fetch(base_url + '/entities', {
		method: 'DELETE',
		body: JSON.stringify({ _id: id }),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function trainModel() {
	return fetch(base_url + '/train').then((res) => res.json());
}

export function changeTelegramWebHook(newUrl) {
	return fetch(base_url + '/telegram_bot?url=' + newUrl).then((res) => res.json());
}

export function getScriptsNoFlujo() {
	return fetch(base_url + '/scriptsNoFlujo').then((res) => res.json());
}

export function putScriptNoFlujo(data) {
	return fetch(base_url + '/scriptsNoFlujo', {
		method: 'PUT',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function getRecordatorios() {
	return fetch(base_url + '/recordatorios').then((res) => res.json());
}

export function deleteRecordatorio(id) {
	return fetch(base_url + '/recordatorios', {
		method: 'DELETE',
		body: JSON.stringify({ _id: id }),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function putRecordatorio(id, data) {
	return fetch(base_url + '/recordatorios', {
		method: 'PUT',
		body: JSON.stringify({ _id: id, recordatorio: data }),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function postRecordatorio(data) {
	return fetch(base_url + '/recordatorios', {
		method: 'POST',
		body: JSON.stringify({ recordatorio: data }),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function putGramaticaFuerte(data) {
	return fetch(base_url + '/gramaticasFuertes', {
		method: 'PUT',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function postGramaticaFuerte(data) {
	return fetch(base_url + '/gramaticasFuertes', {
		method: 'POST',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function deleteGramaticaFuerte(id) {
	return fetch(base_url + '/gramaticasFuertes', {
		method: 'DELETE',
		body: JSON.stringify({ id: id }),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function putGramaticaDebil(data) {
	return fetch(base_url + '/gramaticasDebiles', {
		method: 'PUT',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function postGramaticaDebil(data) {
	return fetch(base_url + '/gramaticasDebiles', {
		method: 'POST',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function deleteGramaticaDebil(id) {
	return fetch(base_url + '/gramaticasDebiles', {
		method: 'DELETE',
		body: JSON.stringify({ id: id }),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function getGramaticasFuertes() {
	return fetch(base_url + '/gramaticasFuertes').then((res) => res.json());
}

export function getGramaticasDebiles() {
	return fetch(base_url + '/gramaticasDebiles').then((res) => res.json());
}

export function getConversaciones(fbPage, channel) {
	return fetch(base_url + '/conversaciones?filter=' + fbPage + '|' + channel).then((res) => res.json());
}

export function getPM2Processes() {
	return fetch(base_url + '/pm2_processes').then((res) => res.json());
}

export function downloadPM2Logs(log_path, filename) {
	return fetch(base_url + '/download_logs?path=' + log_path)
		.then((res) => res.blob())
		.then((blob) => downloadFile(blob, filename));
}

export function restartPM2Process(process_name) {
	return fetch(base_url + '/restart_process?process=' + process_name).then((res) => res.json());
}

export function stopPM2Process(process_name) {
	return fetch(base_url + '/stop_process?process=' + process_name).then((res) => res.json());
}

export function getUsers() {
	return fetch(base_url + '/users').then((res) => res.json());
}

export function getUserRoles() {
	return fetch(base_url + '/roles').then((res) => res.json());
}

export function postUser(data) {
	return fetch(base_url + '/sign_up', {
		method: 'POST',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function editUser(data) {
	return fetch(base_url + '/users', {
		method: 'PUT',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function deleteUser(data) {
	return fetch(base_url + '/users', {
		method: 'DELETE',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function create_new_intents(nuevaArista, intents) {
	if (!nuevaArista.condiciones.length) return;
	const intents_in_db = intents.map((intent) => intent.intent);
	const intents_in_arista = nuevaArista.condiciones.filter((cond) => cond.nombreIE === 'intent').map((cond) => cond.valor);
	const new_intents = intents_in_arista.filter((a) => !intents_in_db.includes(a));
	return fetch(base_url + '/intents/create_multiple', {
		method: 'POST',
		body: JSON.stringify(new_intents),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function create_new_entities(nuevaArista, entities) {
	if (!nuevaArista.condiciones.length) return;
	const entities_in_db = entities.map((entity) => entity.entity);
	const entities_in_arista = nuevaArista.condiciones.filter((cond) => cond.nombreIE !== undefined && cond.nombreIE !== 'intent').map((cond) => cond.nombreIE);
	const new_entities = entities_in_arista.filter((a) => !entities_in_db.includes(a));
	return fetch(base_url + '/entities/create_multiple', {
		method: 'POST',
		body: JSON.stringify(new_entities),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function getArchivos() {
	return fetch(base_url + '/files').then((res) => res.json());
}

export function getChatbotFunctions() {
	return fetch(base_url + '/functions').then((res) => res.json());
}

function download(dataurl, filename) {
	const url = window.URL.createObjectURL(dataurl);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	a.remove();
}

function downloadFile(blob, filename) {
	const url = window.URL.createObjectURL(new Blob([blob]));
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', filename);
	document.body.appendChild(link);
	link.click();
	link.parentNode.removeChild(link);
}

//#region SECCION DE FUNCIONES PARA LA REPORTERIA (LEGACY)

export function getTemas(dates = '') {
	var from = dates.split('|')[0];
	var to = dates.split('|')[1];
	var fbPage = dates.split('|')[2] || 'Todas';

	return fetch(base_url + '/temas', {
		method: 'POST',
		body: JSON.stringify({ from: from, to: to, fbPage: fbPage }),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function downloadTemas() {
	return fetch(base_url + '/download/temas')
		.then((res) => res.blob())
		.then((blob) => download(blob, `Temas.xlsx`));
}

export function downloadConversaciones(from = '', to = '', fbPage = 'Todas') {
	let data = { from: from, to: to, fbPage: fbPage };

	return fetch(base_url + '/download/conversaciones', {
		method: 'POST',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	})
		.then((res) => {
			return res.blob();
		})
		.then((blob) => {
			return download(blob, from && to ? `conversaciones_${from}_${to}.xlsx` : `conversaciones.xlsx`);
		});
}

export function downloadNoEntendidos(from = '', to = '', fbPage = 'Todas') {
	let data = { from: from, to: to, fbPage: fbPage };

	return fetch(base_url + '/download/noEntendidos', {
		method: 'POST',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	})
		.then((res) => {
			return res.blob();
		})
		.then((blob) => {
			return download(blob, from && to ? `noEntendidos_${from}_${to}.xlsx` : `noEntendidos.xlsx`);
		});
}

export function getLegends() {
	return fetch(base_url + '/legends').then((res) => res.json());
}

export function getDayStats(date = '', fbPage = 'Todas', channel = 'Todos') {
	return fetch(base_url + '/dayStats', {
		method: 'POST',
		body: JSON.stringify({ date: date, fbPage: fbPage, channel: channel }),
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

export function getAllFbPages() {
	return fetch(base_url + '/getAllFbPages').then((res) => res.json());
}

export function getAllChannels() {
	return fetch(base_url + '/getAllChannels').then((res) => res.json());
}

//#endregion

//#region SECCION DE FUNCIONES PARA LA REPORTERIA (NEW FEATURES)

export function getAllConversationsData(startDate = new Date(), endDate = new Date()) {
	const from = startDate.toISOString().match(/[0-9]{2,4}-[0-9]{2}-[0-9]{2}/gi)[0];
	const to = endDate.toISOString().match(/[0-9]{2,4}-[0-9]{2}-[0-9]{2}/gi)[0];
	return fetch(base_url + `/all/conversaciones?from=${from}&to=${to}`).then((res) => res.json());
}

export function getAllNotUnderstandedMessagesStats(startDate = new Date(), endDate = new Date()) {
	const from = startDate.toISOString().match(/[0-9]{2,4}-[0-9]{2}-[0-9]{2}/gi)[0];
	const to = endDate.toISOString().match(/[0-9]{2,4}-[0-9]{2}-[0-9]{2}/gi)[0];
	return fetch(base_url + `/all/noentendidos?from=${from}&to=${to}`).then((res) => res.json());
}

export function getAllSubjectsStats() {
	return fetch(base_url + `/all/temas`).then((res) => res.json());
}

export function getAllSubjects() {
	return fetch(base_url + `/all/temas/nombres`).then((res) => res.json());
}

export function analyzeExpression(utterance) {
	return fetch(`${base_url}/analyze`, {
		method: 'POST',
		body: JSON.stringify({ utterance: utterance }),
		mode: 'cors',
		cache: 'no-cache',
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}

//#endregion

export function deleteNodo(id) {
	return fetch(`${base_url}/delete/${id}`, {
		method: 'DELETE',
		mode: 'cors',
		cache: 'no-cache',
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
}
